import React, { useState } from 'react';
import '../css/About.css';

// Safely resolve assets from src or public
function resolveAsset(name) {
  try {
    const req = require.context('../', true, /\.(svg|png|jpe?g)$/);
    const match = req.keys().find(k => k.toLowerCase().includes(name.toLowerCase()));
    if (match) {
      const res = req(match);
      return res.default || res;
    }
  } catch (e) {
    // ignore
  }
  return `${process.env.PUBLIC_URL || ''}/${name}`;
}

const presidentImg = resolveAsset('luisa') || resolveAsset('president') || resolveAsset('committee');
const vpresidentImg = resolveAsset('rachel') || resolveAsset('vpresident') || resolveAsset('committee');
const treasurerImg = resolveAsset('isabel') || resolveAsset('sagan') || resolveAsset('treasurer');
const secretaryImg = resolveAsset('belinda') || resolveAsset('secretary') || resolveAsset('committee');
const eventsImg = resolveAsset('cindy') || resolveAsset('events') || resolveAsset('committee');
const commsImg = resolveAsset('ethan') || resolveAsset('communications') || resolveAsset('committee');
const juliaImg = resolveAsset('julia');
const asadImg = resolveAsset('asad') || resolveAsset('syed');
const hanImg = resolveAsset('han') || resolveAsset('cai');


const COMMITTEE_MEMBERS = [
  {
    id: 'president',
    role: 'President',
    name: 'Luisa Haiß',
    headerClass: 'header-yellow',
    hasPhoto: true,
    photo: presidentImg,
    bio: 'Luisa is founding President of the Oxford Society for Science Communication and Engagement. At Oxford, she is pursuing a PhD in Immunology at the Dunn School of Pathology. Her academic education encompasses medical research, global governance, and communication studies (BSc Molecular Medicine, BA Rhetoric and Latin, MSc Global Governance and Diplomacy). Her particular interest lies in patient-centred clinical research, with a focus on making the patient experience central to how research is designed, communicated and delivered.'
  },
  // {
  //   id: 'treasurer',
  //   // role: 'Treasurer',
  //   name: 'Rachel Andres',
  //   headerClass: 'header-coral',
  //   hasPhoto: true,
  //   photo: vpresidentImg,
  //   bio: 'Hailing all the way from Canada, Rachel is currently studying for a DPhil on the Interdisciplinary Bioscience DTP, focussing on plant-microbe interactions. She’s also a former substitute teacher. Rachel is responsible for keeping the society’s finances in check and sourcing new resources for us where possible.'
  // },
  {
    id: 'communications-officer-isabel',
    role: 'IT officer',
    name: 'Isabel Quinn',
    headerClass: 'header-teal',
    hasPhoto: true,
    photo: treasurerImg,
    bio: 'Isabel is a second-year DPhil student in Biology focussing on how wetland ecosystems respond to environmental pressures. She has held numerous volunteering roles centred on science communication and education. Isabel is passionate about making science accessible for everyone and excited to be on the OSSCE committee for this upcoming year.'
  },
  {
    id: 'events-officer-belinda',
    role: 'Events Officer',
    name: 'Belinda Kusuma',
    headerClass: 'header-yellow',
    hasPhoto: true,
    photo: secretaryImg,
    bio: 'Belinda is a DPhil student in Engineering Sciences, looking to create a mathematical model for brain activity. She is passionate about engaging as many people as possible in communication about science and research. She is looking forward to meeting everyone in OSSCE events as she is continuing her role as Events Office!'
  },
  {
    id: 'treasurer-cindy',
    role: 'Treasurer',
    name: 'Cindy Yeung',
    headerClass: 'header-coral',
    hasPhoto: true,
    photo: eventsImg,
    bio: 'Cindy is a third-year student in Biochemistry with a broad curiosity spanning virology, developmental biology, and public health. She oversees the club’s finances and is eager to expand the conversation beyond the STEM field to engage audiences from all disciplines.'
  },
  {
    id: 'communications-officer-julia',
    role: 'Communications Officer',
    name: 'Julia Bartels',
    headerClass: 'header-teal',
    hasPhoto: true,
    photo: juliaImg,
    bio: "Julia is pursuing an MSc in Clinical and Therapeutic Neuroscience, and is particularly interested in dementia research. She cares about communicating research in clear, digestible, and genuinely engaging ways to spark and nurture people's interest in science. This year she will help do so by posting on social media and promoting events!"
  },
  {
    id: 'communications-officer-asad',
    role: 'Communications Officer',
    name: 'Syed Asad Asif',
    headerClass: 'header-yellow',
    hasPhoto: true,
    photo: asadImg,
    bio: 'Asad is currently pursuing an MSc in Quantum Technologies at the University of Oxford, having come from Pakistan on a Rhodes Scholarship. He is passionate about science communication and outreach. In Pakistan, he taught mathematics to young children through Math Circles and launched an outreach programme to teach mathematics to young girls. Looking ahead, he hopes to improve science literacy through storytelling. His academic interests lie in quantum mechanics and mathematics.'
  },
  {
    id: 'events-officer-han',
    role: 'Events Officer',
    name: 'Han Cai',
    headerClass: 'header-coral',
    hasPhoto: true,
    photo: hanImg,
    bio: 'Han is a 4th-year DPhil student based at the Kennedy Institute of Rheumatology, studying how immune cells are regulated during infection. He believes communication is a key skill for researchers aiming to maximise the reach and impact of their research output. Han is passionate about making scientific research understandable and accessible to the whole of society, as well as promoting public interest in science, and is excited to support OSSCE this year.'
  },
  // {
  //   id: 'communications-officer',
  //   role: 'Communications Officer',
  //   name: 'Ethan Wright',
  //   headerClass: 'header-teal',
  //   hasPhoto: true,
  //   photo: commsImg,
  //   bio: 'Leads OSSCE social media, newsletter production, and external communications to grow our community.'
  // }
];

function About() {
  const [flippedCards, setFlippedCards] = useState({});

  const toggleFlip = (id) => {
    setFlippedCards((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <div className="about-page-wrapper">
      <div className="about-container">
        {/* Intro */}
        <span className="about-eyebrow">ABOUT US</span>
        <h1 className="about-title">
          Welcome to<br />OSSCE!
        </h1>
        <div className="about-yellow-bar" />

        {/* =====================================================
             LEARN - PRACTICE - CONNECT
             ===================================================== */}
        <section className="about-pillars">
          <article className="about-pillar learn">
            <div className="about-pillar-number">01</div>
            <h2>Learn.</h2>
            <p>
              Build practical skills through workshops on storytelling,
              visual communication, social media, public speaking and more.
            </p>
          </article>

          <article className="about-pillar practice">
            <div className="about-pillar-number">02</div>
            <h2>Practice.</h2>
            <p>
              Put your skills into action through opportunities to communicate
              and engage with different audiences and stakeholders.
            </p>
          </article>

          <article className="about-pillar connect">
            <div className="about-pillar-number">03</div>
            <h2>Connect.</h2>
            <p>
              Meet students across disciplines and connect with partners
              and science communication professionals within and beyond Oxford.
            </p>
          </article>
        </section>

        {/* Mission & Aim Cards */}
        <div className="about-cards-grid">
          <div className="about-feature-card">
            <h3>Our mission</h3>
            <p>
             To provide Oxford students and researchers with the skills, experience and community to communicate their research clearly and engage meaningfully with different audiences. 
            </p>
          </div>
          <div className="about-feature-card">
            <h3>Our vision</h3>
            <p>
              A research culture where excellent communication and meaningful engagement are a natural part of being an Oxford researcher.
            </p>
          </div>
        </div>

        {/* Committee Section */}
        <div className="committee-section-title">
          <span className="about-eyebrow center">MEET OUR COMITTEE!</span>
        </div>

        <div className="committee-grid">
          {COMMITTEE_MEMBERS.map((member) => {
            const isFlipped = !!flippedCards[member.id];

            return (
              <div
                key={member.id}
                className={`committee-card-flip-wrap ${isFlipped ? 'is-flipped' : ''}`}
                onClick={() => toggleFlip(member.id)}
                title="Click to flip"
              >
                <div className="committee-card-flip-inner">
                  {/* FRONT */}
                  <div className={`committee-card card-front ${member.headerClass}`}>
                    <div className={`committee-card-header`}>
                      <span>{member.role}</span>
                      <span className="member-name">{member.name}</span>
                    </div>
                    <div className="committee-card-body">
                      {member.hasPhoto ? (
                        <div className="committee-photo-wrap">
                          <img
                            src={member.photo}
                            alt={`${member.name} - ${member.role}`}
                            className="committee-photo-img"
                            onError={(e) => {
                              e.currentTarget.style.display = 'none';
                              if (e.currentTarget.nextSibling) {
                                e.currentTarget.nextSibling.style.display = 'block';
                              }
                            }}
                          />
                          <svg
                            viewBox="0 0 160 210"
                            width="100%"
                            height="auto"
                            fill="none"
                            style={{ display: member.photo ? 'none' : 'block' }}
                          >
                            <path
                              d="M38 185 C32 150 48 105 80 92 C112 105 128 150 122 185 Z"
                              fill="#f2b412"
                              transform="translate(-6, -4)"
                            />
                            <ellipse cx="80" cy="80" rx="36" ry="46" fill="#4a3b32" />
                            <ellipse cx="80" cy="88" rx="26" ry="32" fill="#e8cbb5" />
                            <path
                              d="M58 84 C62 60 98 60 102 84 C100 115 60 115 58 84 Z"
                              fill="#36281e"
                            />
                            <path
                              d="M44 195 C40 160 55 130 80 125 C105 130 120 160 116 195 Z"
                              fill="#f7f7f7"
                              stroke="#1a1a1a"
                              strokeWidth="2"
                            />
                            <path d="M60 145 L60 195 M72 135 L72 195 M88 135 L88 195 M100 145 L100 195" stroke="#1a1a1a" strokeWidth="2" />
                          </svg>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* BACK */}
                  <div className={`committee-card card-back ${member.headerClass}`}>
                    <div className={`committee-card-header`}>
                      <span>About</span>
                      <span className="committee-flip-hint">Click to flip</span>
                    </div>
                    <div className="committee-card-body bio-body">
                      <p className="committee-bio-text">{member.bio}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default About;
